var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('name'),_c('phone'),_c('email'),_c('password'),(_vm.user)?_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('user-data')],1),_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('menu-items')],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }